import { render } from "./ComponenteDisponibilidadCalderaElectrica.vue?vue&type=template&id=2320784e&scoped=true"
import script from "./ComponenteDisponibilidadCalderaElectrica.vue?vue&type=script&lang=js"
export * from "./ComponenteDisponibilidadCalderaElectrica.vue?vue&type=script&lang=js"

import "./ComponenteDisponibilidadCalderaElectrica.vue?vue&type=style&index=0&id=2320784e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2320784e"]])

export default __exports__